import drag from './drag/drag' // 拖拽
const install = function (vm) {
  vm.directive('drag', drag)
}

export default { install }
